import { useGetAllProvincesQuery } from '@exam-center/graphql';
import { Box, Button, Divider, Flex, Form } from '@shared/components';
import { useMemo, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useAdminExamLocationListSearchParams } from '../../hooks';
import { ProvinceSearchSelection } from '../province-search-selection';

export default function AdminExamLocationFilterSection() {
  const { data: allProvincesData } = useGetAllProvincesQuery();

  const [{ provinceId }, { changeProvinceId }] = useAdminExamLocationListSearchParams();

  const provinces = useMemo(
    () => allProvincesData?.ecGetAllProvinces?.provinces ?? [],
    [allProvincesData?.ecGetAllProvinces?.provinces],
  );

  const defaultProvince = useMemo(
    () => provinces.find((item) => item.id === provinceId),
    [provinces, provinceId],
  );

  const formContext = useForm<{ province: { label: string; value: string } }>();

  useEffect(() => {
    if (defaultProvince) {
      formContext.setValue('province', { label: defaultProvince.nameTh, value: provinceId });
    }
  }, [provinceId, defaultProvince, formContext]);

  const provinceValue = formContext.watch('province');

  const handleResetFilter = () => {
    formContext.reset({});
    changeProvinceId('');
  };

  const handleSubmitFilter = () => {
    const { province } = formContext.getValues();
    changeProvinceId(province?.value ?? '');
  };

  return (
    <FormProvider {...formContext}>
      <Form>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(4),
            p: theme.spacing(4),
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: theme.shape.rounded(2),
          })}
        >
          <Box sx={{ width: '260px' }}>
            <ProvinceSearchSelection value={provinceValue} />
          </Box>
          <Divider />
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(2),
              justifyContent: 'flex-end',
            })}
          >
            <Button
              variant='outlined'
              color='secondary'
              sx={{ width: '100px' }}
              onClick={handleResetFilter}
            >
              Reset
            </Button>
            <Button variant='contained' sx={{ width: '100px' }} onClick={handleSubmitFilter}>
              Apply
            </Button>
          </Flex>
        </Flex>
      </Form>
    </FormProvider>
  );
}
